import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cadastro-container" }
const _hoisted_2 = { class: "cadastro-card" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Cadastro de Usuário", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "subtitle" }, "Crie sua conta no Portal de Honorários", -1)),
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleCadastro && $setup.handleCadastro(...args)), ["prevent"])),
        class: "cadastro-form"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { for: "nome" }, "Nome", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "nome",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.usuario.nome) = $event)),
            required: "",
            placeholder: "Digite seu nome"
          }, null, 512), [
            [_vModelText, $setup.usuario.nome]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { for: "sobrenome" }, "Sobrenome", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "sobrenome",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.usuario.sobrenome) = $event)),
            required: "",
            placeholder: "Digite seu sobrenome"
          }, null, 512), [
            [_vModelText, $setup.usuario.sobrenome]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { for: "email" }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            id: "email",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.usuario.email) = $event)),
            required: "",
            placeholder: "Digite seu email"
          }, null, 512), [
            [_vModelText, $setup.usuario.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { for: "telefone" }, "Telefone", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            id: "telefone",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.usuario.telefone) = $event)),
            required: "",
            placeholder: "Digite seu telefone"
          }, null, 512), [
            [_vModelText, $setup.usuario.telefone]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { for: "senha" }, "Senha", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            id: "senha",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.usuario.senha) = $event)),
            required: "",
            placeholder: "Digite sua senha"
          }, null, 512), [
            [_vModelText, $setup.usuario.senha]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[13] || (_cache[13] = _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary"
          }, [
            _createElementVNode("i", { class: "fas fa-user-plus" }),
            _createTextVNode(" Cadastrar ")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.voltarLogin && $setup.voltarLogin(...args)))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
            _createTextVNode(" Voltar ", -1)
          ]))])
        ])
      ], 32)
    ])
  ]))
}